import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DataElement, Product } from 'src/app/shared/models/common';
import { NgRedux } from '@redux/redux-compatibility.service';
import { AppState } from 'src/app/shared/redux/store';
import { CatService } from 'src/app/shared/services/cat.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { Catalog } from 'src/app/shared/models/cat.model';

@Component({
    selector: 'create-cat',
    templateUrl: './create-cat.component.html',
    styleUrls: ['./create-cat.component.scss'],
    standalone: false
})
export class CreateCatComponent implements OnInit {
  @Input() extSw: boolean = false;
  @Output() onClose = new EventEmitter();
  @Output() onCreate = new EventEmitter();

  catDescr: string;
  product: DataElement;
  type: DataElement;
  refMatchType: DataElement;
  lang: DataElement;
  claimsManagementType: DataElement;
  isMaster: boolean = false;
  useOldVersion: boolean = false;
  saving: boolean;

  private previousIsMaster: boolean = false;

  libraryTypeOptions = [
    { label: 'translate.general.productLibrary', value: false },
    { label: 'translate.general.isMaster', value: true }
  ];

  onUseOldVersionChange() {
    if (!this.useOldVersion) {
      this.type = null;
      this.lang = null;
    }
    if (this.isMaster) {
      this.onIsMasterChange();
    }
  }

  onIsMasterChange(event?: any) {
    if (event && (event.value === null || event.value === undefined)) {
      this.isMaster = this.previousIsMaster;
      return;
    }
    if (event) {
      this.previousIsMaster = event.value;
    }
    if (this.isMaster && this.masterLibraryExists) {
      this.isMaster = false;
      this.previousIsMaster = false;
      return;
    }
    if (this.isMaster) {
      if (this.claimsManagementTypesList && this.claimsManagementTypesList.length > 0) {
        if (this.useOldVersion) {
          this.claimsManagementType = this.claimsManagementTypesList[1];
        } else {
          this.claimsManagementType = this.claimsManagementTypesList[0];
        }
      }
    } else {
      this.claimsManagementType = null;
    }
  }

  get claimsManagementTypesList(): DataElement[] {
    return this.ngRedux.getState().claimsManagementTypes;
  }

  get productList(): Product[] {
    return this.ngRedux.getState().productList;
  }

  get typeList(): DataElement[] {
    return this.ngRedux.getState().catTypeList;
  }

  get refMatchTypeList(): DataElement[] {
    return this.ngRedux.getState().refMatchTypeList;
  }

  get langList(): DataElement[] {
    return this.ngRedux.getState().catLangList;
  }

  get catList(): Catalog[] {
    return this.extSw
      ? this.ngRedux.getState().extCatalogList
      : this.ngRedux.getState().catalogList;
  }

  get masterLibraryExists(): boolean {
    return this.catList?.some((c) => c.isMaster === true) || false;
  }

  get enableSubmit(): boolean {
    const basicValid = this.catDescr != null && this.refMatchType != null;
    if (!basicValid) {
      return false;
    }

    if (this.isMaster) {
      if (this.claimsManagementType == null) {
        return false;
      }
    } else {
      if (this.product == null) {
        return false;
      }
    }

    if (this.useOldVersion) {
      if (!this.extSw && this.type == null) {
        return false;
      }
      if (this.lang == null) {
        return false;
      }
    }

    return true;
  }

  constructor(
    private ngRedux: NgRedux<AppState>,
    private catService: CatService,
    private authService: AuthService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {}

  close() {
    this.onClose.emit();
  }

  save() {
    this.saving = true;

    let cat = new Catalog();
    cat.catDescr = this.catDescr;
    
    if (this.isMaster) {
      const defaultProduct = this.productList?.find((p: any) => p.isEnvDefault || p.is_env_default);
      cat.productId = defaultProduct ? defaultProduct.id : null;
    } else {
      cat.productId = this.product?.id;
    }

    cat.claimsManagementType = this.claimsManagementType?.id;

    cat.typeCode = this.extSw ? 'EXT' : this.type?.id;
    cat.refMatchTypeCode = this.refMatchType.id;
    cat.extSw = this.extSw;
    cat.langCode = this.lang?.id;
    cat.isMaster = this.isMaster;
    cat.useOldVersion = this.useOldVersion;

    this.catService.createCat(cat).subscribe(
      (data) => {
        const catId = data.reply.requestResult.data.catId;
        
        cat.catId = catId;
        cat.catAssetTypeList.push(...this.ngRedux.getState().assetTypes);
        
        this.catService.updCat(cat).subscribe(
          (data) => {
            this.saving = false;
            this.onCreate.emit();
          },
          (err) => {
            cat.catAssetTypeList = [];
            this.saving = false;
          }
        );
      },

      (err) => (this.saving = false)
    );
  }
}
